"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LabeledSwitch = _ref => {
  let {
    label,
    checked,
    onChange
  } = _ref;
  const onChangeHandler = (0, _react.useCallback)(event => {
    onChange(event.target.checked);
  }, [onChange]);
  return /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_material.Switch, {
      checked: checked,
      onChange: onChangeHandler,
      sx: {
        width: 70,
        height: 45,
        padding: "13px 12px",
        marginLeft: "4px",
        "& .MuiSwitch-switchBase": {
          "&.Mui-checked": {
            transform: "translateX(25px)"
          }
        },
        "& .MuiSwitch-thumb": {
          width: 27,
          height: 27
        },
        "& .MuiSwitch-track": {
          borderRadius: "9.5px"
        }
      }
    }),
    label: label,
    labelPlacement: "start",
    sx: {
      marginRight: "-9px",
      "& .MuiFormControlLabel-label": {
        fontWeight: "700",
        fontSize: "1.125rem",
        color: "var(--color-text-secondary-2)"
      }
    }
  });
};
var _default = exports.default = LabeledSwitch;